import { gql } from "@apollo/client";

export const LoginCodeMutation = gql`
  mutation AuthVerifyCode(
    $code: String!
    $sessionId: String!
    $region: AWSRegions!
    $username: String!
  ) {
    authVerifyCode(
      code: $code
      sessionId: $sessionId
      region: $region
      username: $username
    ) {
      idToken
      accessToken
      refreshToken
    }
  }
`;

export const SendAuthCodeMutation = gql`
  mutation authRequestCode($username: String!, $region: AWSRegions!) {
    authRequestCode(username: $username, region: $region) {
      sessionId
    }
  }
`;
